import headerModule from "./headerModule"

headerModule.controller("headerController", ["$scope", ($scope)=>{
    if(typeof $scope.menuCollapsed === "undefined"){
        $scope.menuCollapsed = false
    }
}])